import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dotpipeh'
})
export class DotpipehPipe implements PipeTransform {

  transform(tag: string, char: string): unknown {

    if(char==='|h' && tag.indexOf(char)>0 && tag.indexOf('|b')>0) { 
      return ':';
    } else if(char==='|b' && tag.indexOf(char)==-1 && tag.indexOf('|c')>0) {
      return '/';
    }
    else return '';
  }

}
